import { api } from "../../services/NetworkBase";

export async function GetAllCoolerShippings() {
  try {
    let response = await api.get("vlp/cooler-shippings").json();    
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetCoolerShippingById(shippingId) {
  try {
    let response = await api.get(`vlp/cooler-shippings/${shippingId}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetLatestShippingByCoolerId(coolerId) {
  try {
    let response = await api
      .get(`vlp/cooler-shippings/cooler/${encodeURIComponent(coolerId)}/latest`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetShippingsByClient(clientAccountNumber) {
  try {
    let response = await api
      .get(`vlp/cooler-shippings/client/${encodeURIComponent(clientAccountNumber)}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveCoolerShipping(shipping) {
  try {
    let response = await api.post("vlp/cooler-shippings", { json: shipping });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateCoolerShipping(shipping) {
  try {
    let response = await api.put("vlp/cooler-shippings", { json: shipping });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteCoolerShipping(shippingId) {
  try {
    const encodedUrl = encodeURIComponent(shippingId);
    let response = await api
      .delete(`vlp/cooler-shippings/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}